import { render, staticRenderFns } from "./profits.vue?vue&type=template&id=9d9ca816&scoped=true"
import script from "./profits.vue?vue&type=script&lang=js"
export * from "./profits.vue?vue&type=script&lang=js"
import style0 from "./profits.vue?vue&type=style&index=0&id=9d9ca816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9ca816",
  null
  
)

export default component.exports